/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Desk_Sso_Error_TitleInputs */

const vi_desk_sso_error_title = /** @type {(inputs: Desk_Sso_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không thể mở trang hỗ trợ`)
};

/**

* @param {Desk_Sso_Error_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const desk_sso_error_title = /** @type {((inputs?: Desk_Sso_Error_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Desk_Sso_Error_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_desk_sso_error_title(inputs)
});